module.exports = __webpack_public_path__ + "img/anli_bg.b9e0bf2.png";